import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { wrapperSizeAtom } from '@src/atoms';

export const useWrapperSize = (ref: React.RefObject<SVGSVGElement>) => {
  const [, setWrapperSize] = useAtom(wrapperSizeAtom);
  useEffect(() => {
    if (ref?.current) {
      const { clientWidth, clientHeight } = ref.current;
      setWrapperSize({ x: clientWidth, y: clientHeight });
    }
  }, [ref, setWrapperSize]);
};
